import { DataTablePagination } from "app/components/pagination/DataTablePagination";
import {
  useQueryResponseLoading,
  useQueryResponsePagination,
} from "../../core/QueryResponseProvider";
import { useQueryRequest } from "../../core/QueryRequestProvider";

const BugReportingListPagination = () => {
  const pagination = useQueryResponsePagination();
  const isLoading = useQueryResponseLoading();
  const { updateState } = useQueryRequest();

  const updatePage = (pageNumber: number | null) => {
    if (!pageNumber || isLoading || pagination.pageNumber === pageNumber) {
      return;
    }

    updateState({ pageNumber, pageSize: pagination.pageSize || 10 });
  };

  return (
    <DataTablePagination
      pagination={pagination}
      isLoading={isLoading}
      onPageChange={updatePage}
    />
  );
};

export { BugReportingListPagination };
